import { useMatches } from '@tanstack/react-router';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { APP_TITLE, buildPageTitle } from '@/lib/page-title';

export function DocumentTitle(): ReactElement {
	const { t } = useTranslation();

	const titleKey = useMatches({
		select: (matches) => matches.findLast((match) => match.staticData.titleKey)?.staticData.titleKey,
	});

	const title = titleKey ? buildPageTitle(t(titleKey)) : APP_TITLE;

	return <title>{title}</title>;
}
